import { PdfLink } from "@shared-kernel/primary/shared/pdf-preview-hover-card/pdf-link";
import type { SpeakerDisplayData } from "./types";

interface SpeakersDisplayProps {
  speakers: SpeakerDisplayData[];
}

export const SpeakersDisplay = ({ speakers }: SpeakersDisplayProps) => {
  if (!speakers || speakers.length === 0) {
    return null;
  }

  return (
    <div className="text-sm">
      <span className="text-muted-foreground">Intervenants ({speakers.length}):</span>
      <ul className="mt-1 list-inside list-disc space-y-1">
        {speakers.map(speaker => (
          <li key={`${speaker.firstName}-${speaker.lastName}`}>
            <span className="inline-flex items-center gap-1">
              {speaker.firstName} {speaker.lastName}
              {speaker.resumeUrl && (
                <>
                  {" - "}
                  <PdfLink documentUrl={speaker.resumeUrl} label="Voir le CV" />
                </>
              )}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};
